<script setup lang="ts">
import type { InputPrimaryEvent } from '@shared/ui/fields'
import type { ImageBlock } from '../../../model/assessments/interfaces'
import type { ContentBlockOwner } from '../../../model/assessments/store/interfaces'

import { InputPrimary } from '@shared/ui/fields'

import { useContentBlockImage } from '../../../model/assessments/content-block-editors.hook'
import ImageUploader from './ImageUploader.vue'

defineOptions({
  name: 'ContentBlockImage',
})

const props = defineProps<{
  owner: ContentBlockOwner
  index: number
  block: ImageBlock
}>()

const {
  setUrl,
  setAlt,
} = useContentBlockImage({
  owner: () => props.owner,
  index: () => props.index,
})
</script>

<template>
  <div class="content-block-image">
    <!-- `asset.url` holds either an uploaded object path or an external URL; the uploader owns
         that distinction, and this block only forwards whichever string comes back.

         Alt text goes in the uploader's right-hand column, beside the picture it describes,
         rather than under the whole block. -->
    <ImageUploader
      :value="block.asset.url"
      :alt="block.alt"
      @update:value="setUrl"
    >
      <template #fields>
        <!-- `alt` is required by the schema, not a nicety — an image without it fails
             validation. -->
        <InputPrimary
          name="alt"
          label="Alt text"
          required
          :value="block.alt"
          placeholder="What the image shows"
          @input="(event: InputPrimaryEvent) => setAlt(String(event.value))"
        />
      </template>
    </ImageUploader>
  </div>
</template>

<style scoped lang="scss" src="./ContentBlockImage.scss" />
